import { FunctionalComponent, h } from 'preact';
import { SubServiceInfo, SubServiceInfoLabel, SubServicesInfoArrow } from './SubServices.styles';
import { useSettingsContext } from '../../contexts/SettingsContext';

type Divider = 'arrow' | 'bullet';

interface Props {
  divider?: Divider;
  size: number;
}

const SubServicesInfo: FunctionalComponent<Props> = ({ divider = 'arrow', size }) => {
  const { labels } = useSettingsContext();

  if (!labels) {
    return null;
  }

  const subServiceSingOrPlural = size === 1 ? labels.general.subservice : labels.general.subservices;

  return (
    <SubServiceInfo showBullet={divider === 'bullet'}>
      {size}
      <SubServiceInfoLabel>{subServiceSingOrPlural}</SubServiceInfoLabel>
      {divider === 'arrow' && <SubServicesInfoArrow color="rgb(48, 48, 48)" direction="right" />}
    </SubServiceInfo>
  );
};

export default SubServicesInfo;
